import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import Bureau from './Bureau';
import CarteInfoBureau from './CarteInfoBureau';
import ChangeInfo from './ChangeInfo';
import { Padding } from '@mui/icons-material';

function RecapRetraitInfo() {
  const state = useSelector((state) => state.change.value);
console.log('rrrrr:::',state)
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Box sx={{
      padding: 2,
      // backgroundColor: "black",
      borderRadius: 2,
      // color: "goldenrod"
    }}>
        <Typography variant="h5">Bureau de retrait</Typography>
        <CarteInfoBureau Bureau={state?.bureau}/>
        <Divider sx={{padding:1}}/>
        <Typography variant="h5">Montants</Typography>
        <ChangeInfo />
      </Box>
  );
}

export default RecapRetraitInfo;
